module.exports = __webpack_public_path__ + "static/media/animated_ashutosh.02ab494e.png";